/**
 * SummaryCards - Компактный виджет баланса за месяц (как в mobile)
 * Название месяца + 3 плашки: Доходы, Расходы, Баланс
 */

import React from 'react';
import { formatCurrency } from '../../utils/format';
import { useTranslation } from 'react-i18next';
import './SummaryCards.css';

interface SummaryCardsProps {
  income: number;
  expense: number;
  balance: number;
  currency: string;
  language?: string;
}

export function SummaryCards({
  income,
  expense,
  balance,
  currency,
  language = 'ru',
}: SummaryCardsProps) {
  const { t } = useTranslation();
  const monthName = new Date().toLocaleDateString(language, { month: 'long' });
  const monthTitle = monthName.charAt(0).toUpperCase() + monthName.slice(1);

  return (
    <div className="compact-balance-widget">
      <div className="compact-balance-widget__card">
        <div className="compact-balance-widget__header">
          <h2 className="compact-balance-widget__month">{monthTitle}</h2>
        </div>
        
        <div className="compact-balance-widget__stats">
          <div className="compact-balance-widget__stat compact-balance-widget__stat--income">
            <span className="compact-balance-widget__label">{t('home.income')}</span>
            <span className="compact-balance-widget__amount compact-balance-widget__amount--income">
              {formatCurrency(income, currency)}
            </span>
          </div>
          
          <div className="compact-balance-widget__stat compact-balance-widget__stat--expense">
            <span className="compact-balance-widget__label">{t('home.expenses')}</span>
            <span className="compact-balance-widget__amount compact-balance-widget__amount--expense">
              {formatCurrency(expense, currency)}
            </span>
          </div>
          
          <div className="compact-balance-widget__stat compact-balance-widget__stat--balance">
            <span className="compact-balance-widget__label">{t('home.balance')}</span>
            <span className={`compact-balance-widget__amount ${balance >= 0 ? 'compact-balance-widget__amount--income' : 'compact-balance-widget__amount--expense'}`}>
              {balance < 0 ? '-' : ''}{formatCurrency(Math.abs(balance), currency)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
